/**
 * Converts Strapi/GraphQL CTA test id enum to data-testid format.
 * CMS returns enums with underscore (e.g. questions_with_image_cta);
 * data-testid expects kebab-case (e.g. questions-with-image-cta).
 */
export function cmsCtaTestIdToDataTestId(
    value: string | undefined | null
): string | undefined {
    if (value == null || value === "") return undefined;
    return value.replace(/_/g, "-");
}
